var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncomprehensible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 33.4,
    r: 11.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3,68.4v-9.5c0-0.8-0.4-1.6-1-2.1c-0.7-0.5-1.5-0.6-2.3-0.4l-2.2,0.7c-1.3-5.1-5.7-8.8-10.9-9.6     c-2.5,1.5-5.3,2.3-8.4,2.3c-3.1,0-5.9-0.9-8.4-2.3c-5.2,0.8-9.6,4.6-10.9,9.6l-2.2-0.7c-0.8-0.2-1.6-0.1-2.3,0.4     c-0.7,0.5-1,1.2-1,2.1v9.5c-2.2,0.4-3.9,2.3-3.9,4.6V75c0,2.3,1.7,4.2,3.9,4.6v8.6c0,1.1,0.7,2.1,1.8,2.4l22.2,6.8     c0.2,0.1,0.5,0.1,0.7,0.1c0.3,0,0.5,0,0.7-0.1l22.2-6.8c1.1-0.3,1.8-1.3,1.8-2.4v-8.6c2.2-0.4,3.9-2.3,3.9-4.6v-2.1     C94.2,70.6,92.5,68.7,90.3,68.4z M63,91.5l-17.1-5.2v-24L63,67.5V91.5z M85.2,86.3l-17.1,5.2v-24l17.1-5.2V86.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6,42.3l-2.9-8.8c4.2-8,3-18.1-3.7-24.8c-8.3-8.3-21.7-8.3-30,0c-8.3,8.3-8.3,21.7,0,30c6.7,6.7,16.8,7.9,24.8,3.7     l8.8,2.9C47.5,45.9,49.2,44.2,48.6,42.3z M27.3,36.1c-1.4,0-2.6-1.2-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6c1.4,0,2.6,1.2,2.6,2.6     C30,34.9,28.8,36.1,27.3,36.1z M33.7,22.6c-1,1.4-2.1,2.1-2.8,2.7c-0.9,0.6-1.2,0.9-1.3,2.3c0,0.6-0.6,1.1-1.2,1.1h-1.9     c-0.7,0-1.3-0.6-1.2-1.3c0.3-3.3,1.5-4.4,3.1-5.6c0.7-0.5,1.2-0.9,1.8-1.7c0.6-0.8,0.7-2,0.2-2.9c-0.3-0.7-1.2-1.8-3.3-1.8     c-2.7,0-3.6,1.7-3.8,3.1c-0.1,0.6-0.6,1-1.2,1h-1.9c-0.7,0-1.3-0.6-1.2-1.4c0.5-3.6,3.1-7,8.1-7c3.2,0,5.8,1.5,7.1,4.1     C35.4,17.6,35.2,20.5,33.7,22.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomprehensible);
export default __webpack_public_path__ + "static/media/incomprehensible.b820575ca4b986d4009551f27256c4d7.svg";
export { ForwardRef as ReactComponent };